var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g({ staticClass: "media-preview" }, _vm.$listeners),
    [
      _c(
        "placeholder",
        [
          _c(
            "svg",
            {
              attrs: {
                slot: "placeholder",
                viewBox: "0 0 300 300",
                width: "100%",
                height: "100%"
              },
              slot: "placeholder"
            },
            [
              _c("rect", {
                attrs: { x: "0", y: "0", width: "100%", height: "100%" }
              })
            ]
          ),
          _c("template", { slot: "main" }, [
            _c("img", {
              attrs: {
                src: _vm.imageCrop(
                  _vm.imageSize(
                    _vm.media.preview_image.src,
                    _vm.size || "160x160"
                  ),
                  "center"
                ),
                alt: _vm.getProductImageAlt(_vm.media),
                loading: "lazy"
              }
            })
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }